import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { browserLanguage, isExternalLink, isTypeof, thfLocaleDefault } from '../../../utils/util';

import { thfPageLoginLiteralsDefault } from './../thf-page-login-base.component';
import { ThfPageLoginRecovery } from '../interfaces/thf-page-login-recovery.interface';

@Component({
  selector: 'thf-page-login-popover',
  templateUrl: './thf-page-login-popover.component.html'
})

/**
 * @docsPrivate
 *
 * @description
 *
 * Componente para definiÃ§Ã£o da mensagem de aviso de bloqueio do `thf-page-login`.
 */
export class ThfPageLoginPopoverComponent implements OnInit {

  literals;
  literalParams;
  recoveryType: string;

  private _recovery: string | Function | ThfPageLoginRecovery;
  private _remainingAttempts: number;
  private _selectedLanguage: string;

  /** exibe o link de 'esqueci minha senha' e verifica se o valor Ã© um link interno ou externo */
  @Input('t-recovery') set recovery(value: string | Function | ThfPageLoginRecovery) {
    this._recovery = value;

    if (isTypeof(value, 'string')) {
      this.recoveryType = isExternalLink(value) ? 'externalLink' : 'internalLink';
    }
  }

  get recovery() {
    return this._recovery;
  }

  /** define se a mensagem deverÃ¡ ser exibida caso seja maior que 0(zero) */
  @Input('t-remaining-attempts') set remainingAttempts(value: number) {
    this._remainingAttempts = value;
    this.getLiterals(this.selectedLanguage);
  }

  get remainingAttempts() {
    return this._remainingAttempts;
  }

  /** define o idioma da mensagem conforme selecionado no 'thf-page-login' */
  @Input('t-selected-language') set selectedLanguage(value: string) {
    this._selectedLanguage = value;
    this.getLiterals(value);
  }

  get selectedLanguage() {
    return this._selectedLanguage;
  }

  /** se 't-recovery' for do tipo Function ou ThfPageLoginRecovery, emite para o mÃ©todo 'openUrl' do componente 'thf-page-login' */
  @Output('t-forgot-password') forgotPassword = new EventEmitter<any>();

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {
    this.getLiterals(this.selectedLanguage);
  }

  onForgotPasswordClick(recovery) {
    this.forgotPassword.emit(recovery);
  }

  private getLiterals(language?: string) {
    language = language || browserLanguage();

    this.literalParams = this.remainingAttempts;

    this.literals = {
      ...thfPageLoginLiteralsDefault[thfLocaleDefault],
      ...thfPageLoginLiteralsDefault[language],
    };

    this.changeDetector.detectChanges();
  }

}
